export default __webpack_public_path__ + "static/media/logo.155a2e90.svg";